import { render, staticRenderFns } from "./AlarmSettingsTable.vue?vue&type=template&id=5470bc5e&scoped=true&"
import script from "./AlarmSettingsTable.vue?vue&type=script&lang=js&"
export * from "./AlarmSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470bc5e",
  null
  
)

export default component.exports